import $ from "jquery";
import { dispatchEvent } from "./utils";

export default function (ep, options) {

	const $container = ep.find('.ccs-logo-windows11-body');

	if (!$container.length) {
		return;
	}

	const $disclaimerSection = ep.find('.ccs-logo-windows11-disclaimer-body-mobile');

	function updateNavIndicatorPosition() {
		var $slider = $container.find('.ccs-logo-windows11-slider');
		var $selectedTab = $container.find('.ccs-logo-windows11-nav-link[aria-selected="true"]');
		var position = $selectedTab.position().left + ($selectedTab.width() / 2) - ($slider.width() / 2);
		$slider.css({ 'transform': 'translateX(' + position + 'px)' });
	}

	function resize() {
		updateNavIndicatorPosition();
		$container.toggleClass("ccs-logo-windows11-mobile", $container.width() <= 669);
		$container.toggleClass("ccs-logo-windows11-logodesktop", $container.width() > 669 && $container.width() <= 795);
		$container.toggleClass("ccs-logo-windows11-desktop", $container.width() > 795);
		$container.toggleClass("ccs-logo-windows11-small", $container.width() < 230);

		// Update disclaimer position for tablets
		$('.ccs-logo-windows11-disclaimer-body').toggleClass('ccs-logo-windows11-medium', $container.width() > 669 && $container.width() <= 900);
	}

	/* Used remove class instead of toggle as it works better in window resize */
	$(window).on('load resize', function () {
		resize();
	});

	/* Nav menu tabs */
	const $tabContainer = $container.find('.ccs-logo-windows11-nav-select [role="tab"]');
	const $mobileNav = $container.find('.ccs-logo-windows11-mobile-nav');
	var animatingTimeout = false;
	$tabContainer.click(function (e) {
		var $clickedTab = $(this);
		var $tablist = $clickedTab.closest('[role="tablist"]');
		var $tabs = $tablist.find('[role="tab"]');
		var $panels = $($tabs.map(function (i, e) { return document.getElementById($(e).attr('aria-controls')) }));
		$tabs.attr('aria-selected', 'false');
		$panels.addClass("ccs-logo-windows11-panel-hide");
		$panels.removeClass("ccs-logo-windows11-panel-show");

		$clickedTab.attr('aria-selected', 'true');
		$(document.getElementById($clickedTab.attr('aria-controls'))).addClass("ccs-logo-windows11-panel-show");
		$(document.getElementById($clickedTab.attr('aria-controls'))).removeClass("ccs-logo-windows11-panel-hide");

		$disclaimerSection.removeClass('ccs-logo-windows11-show');
		$mobileNav.text($clickedTab.text());

		setTimeout(function () {
			$('.ccs-logo-windows11-panel-show').find('.ccs-logo-windows11-hotspot').first().focus();
		}, 500);

		// animated status bar transition
		$tablist.addClass('ccs-logo-windows11-slider-animating');
		updateNavIndicatorPosition();
		if (animatingTimeout) { clearTimeout(animatingTimeout); }
		animatingTimeout = setTimeout(function () {
			$tablist.removeClass('ccs-logo-windows11-slider-animating');
		}, 500);

		e.preventDefault();

		const context = {
			type: $clickedTab.text() + " tab select"
		};

		dispatchEvent(options.logCall, e.target, "feature-click", context);
	});

	/* Add Movile Nav Drawer */
	const $navContainer = $container.find('.ccs-logo-windows11-nav-div');
	const $link = $navContainer.find('.ccs-logo-windows11-nav-link');

	$mobileNav.click(function () {
		$mobileNav.toggleClass('ccs-logo-windows11-active');
		$navContainer.toggleClass('ccs-logo-windows11-nav-div-show');
	});

	$link.click(function () {
		$mobileNav.toggleClass('ccs-logo-windows11-active');
		$navContainer.removeClass('ccs-logo-windows11-nav-div-show');
	});

	/* Disclaimer */
	const $disclaimer = $container.find('.ccs-logo-windows11-nav-expand');
	$disclaimer.click(function () {
		$('.ccs-logo-windows11-nav').toggleClass('ccs-logo-windows11-open');
		$('.ccs-logo-windows11-nav-select').toggleClass('ccs-logo-windows11-hide');
		$('.ccs-logo-windows11-nav-expand button.ccs-logo-windows11-closeBtn').toggleClass('ccs-logo-windows11-hide');
		$('.ccs-logo-windows11-disclaimer-body').toggleClass('ccs-logo-windows11-show');
		$('#ccs-logo-windows11-nav-disclaimer').toggleClass('ccs-logo-windows11-hide');

		const context = {
			type: $('.ccs-logo-windows11-disclaimer-body.ccs-logo-windows11-show').length > 0 ? "open disclaimer" : "close disclaimer",
		};

		dispatchEvent(options.logCall, $disclaimerSection, "feature-click", context);

		setTimeout(function () {
			$('section.ccs-logo-windows11-sectionblur').toggleClass('ccs-logo-windows11-blur');
		}, 200);

	});
	/* Disclaimer - Mobile */
	const $disclaimerMobile = $container.find('.ccs-logo-windows11-mobile-disclaimer');
	$disclaimerMobile.click(function () {
		$disclaimerSection.toggleClass('ccs-logo-windows11-show');
	});


	/* Hotspots */
	const $hotspots = ep.find('.ccs-logo-windows11-hotspot');
	$hotspots.each(function () {
		var $hotspot = $(this);
		var $modal = $(document.getElementById($hotspot.attr('aria-controls')));

		$hotspot.click(function (e) {
			$hotspot.attr("aria-pressed", "true");
			$modal.attr("aria-hidden", "false")
				.attr("aria-modal", "true")
				.addClass("ccs-logo-windows11-active");
			toggleBlur();
			setTimeout(function () {
				document.activeElement.blur();
				$modal.find('.ccs-logo-windows11-closeBtn').focus();
			}, 500);

			if ($('.ccs-logo-windows11-card-image').hasClass('ccs-logo-windows11-play-video')) {
				var $video = $modal.find('.ccs-logo-windows11-vid');
				if ($video.length > 0) {
					$video[0].play();
				}
			}

			e.preventDefault();
			intializeVideo($modal);

			const context = {
				type: "open hotspot " + e.target.textContent
			}
			dispatchEvent(options.logCall, e.target, "feature-click", context);

		});

		$modal.find('.ccs-logo-windows11-closeBtn, .ccs-logo-windows11-modal-bg').click(function (e) {
			$hotspot.attr("aria-pressed", "false");
			$modal.attr("aria-hidden", "true")
				.attr("aria-modal", "false")
				.removeClass("ccs-logo-windows11-active");
			toggleBlur();
			setTimeout(function () {
				$hotspot.attr("aria-pressed", "false").focus();
			}, 500);
			e.preventDefault();

			stopVideo($modal);

			const context = {
				type: "close hotspot"
			}

			dispatchEvent(options.logCall, e.target, "feature-click", context);
		});

	});

	function intializeVideo($modal) {
		const $videoContainer = $modal.find('.ccs-logo-windows11-video');

		if ($videoContainer.length === 0)
			return;

		var $player = $videoContainer.ccsVideoPlayer("getPlayer");

		if ($player === null) {

			var settings = {
				file: $videoContainer.data("video-url"),
				image: $videoContainer.data("video-thumbnail-url"),
				transcodedFile: $videoContainer.data("video-transcoded-url"),
				width: "100%",
				playOnInit: options.features.autoPlayVideoInViewPort,
				mute: false,
				volume: 80,
				pluginPath: options.video.pluginPath,
				tracking: {
					logCall: options.logCall
				}
			};

			settings = $.extend(settings, { height: $videoContainer.height() });

			$player = $videoContainer.ccsVideoPlayer(settings);

			if (options.features.autoPlayVideoInViewPort) {
				// auto replay video if auto play is enabled
				$player.mejs.media.addEventListener('ended',
					function () {
						$player.setCurrentTime(0);
						$player.play();
						$player.hideControls();
					});
			}
		}
		else if (options.features.autoPlayVideoInViewPort) {
			$player.setCurrentTime(0);
			$player.play();
		}
	}

	function stopVideo($modal) {
		const $videoContainer = $modal.find('.ccs-logo-windows11-video');

		if ($videoContainer.length === 0)
			return;

		var $player = $videoContainer.ccsVideoPlayer("getPlayer");

		if ($player !== null) {
			$player.pause();
		}
	}

	/* Blur background toggle */
	function toggleBlur() {
		var sectionBlur = document.querySelectorAll('section.ccs-logo-windows11-sectionblur');
		for (var i = 0; i < sectionBlur.length; i++) {
			sectionBlur[i].classList.toggle('ccs-logo-windows11-active');
		}
		var navBlur = document.querySelector('nav.ccs-logo-windows11-navblur');
		navBlur.classList.toggle('ccs-logo-windows11-active');
	};

	resize();
}
